'use client';

import { CommandGroup, CommandItem } from '@/components/ui/command';
import type { CommandOpenTab } from '@/components/command-menu/types';
import type { WorkspaceOpenTabSearchResult } from '@/lib/workspace-open-tab-search';
import type { CommandOpenTabsCopy } from '@/i18n/command-open-tabs-copy';
import { Check, FileText } from 'lucide-react';
import { ItemIcon } from '@/components/command-menu/primitives';

export function OpenTabRows({
  results,
  copy,
  onSelect,
}: {
  results: WorkspaceOpenTabSearchResult<CommandOpenTab>[];
  copy: CommandOpenTabsCopy;
  onSelect: (tab: CommandOpenTab) => void;
}) {
  if (results.length === 0) return null;
  return (
    <CommandGroup heading={copy.heading}>
      {results.map(({ item, matchKind, snippet }) => (
        <CommandItem
          key={item.id}
          value={item.id}
          onSelect={() => onSelect(item)}
          className="items-start"
        >
          <ItemIcon icon={FileText} />
          <span className="min-w-0 flex-1">
            <span className="flex min-w-0 items-center gap-2">
              <span className="truncate text-sm font-medium">{item.title}</span>
              {matchKind === 'content' ? (
                <span className="bg-muted text-muted-foreground shrink-0 rounded px-1.5 py-0.5 text-[10px]">
                  {copy.contentMatch}
                </span>
              ) : null}
            </span>
            <span className="text-muted-foreground/65 block truncate text-[11px]">
              {snippet ?? item.path}
            </span>
          </span>
          {item.isActive ? (
            <span
              className="text-muted-foreground flex size-5 shrink-0 items-center justify-center"
              title={copy.current}
            >
              <Check className="size-3" aria-hidden="true" />
              <span className="sr-only">{copy.current}</span>
            </span>
          ) : null}
        </CommandItem>
      ))}
    </CommandGroup>
  );
}
